import { ws } from "../../../utils/common";

export const getHistoryEventWS = async ({ id_association }) => {
    const res = await ws(
        "GET",
        process.env.REACT_APP_ENDPOINT + "event/history/" + id_association,
        null,
        null,
        true
    );


    if (res.error) {
        throw res.data;
    } else {
        return res.data;
    }
}

export const getEventsOfAssociationWS = async ({ id_association }) => {
    const res = await ws(
        "GET",
        process.env.REACT_APP_ENDPOINT + "event/association/" + id_association,
        { only_active: true },
        null,
        true
    );

    if (res.error) {
        throw res.data.title;
    } else {
        return res.data;
    }
}